import React from 'react';
import { Menu, Popover, Position, UserIcon } from 'evergreen-ui';
import { IconButton } from '../../components';

export const ProfilePopover = () => {
    return (
        <Popover
            position={Position.BOTTOM_RIGHT}
            content={
                <Menu>
                    <Menu.Item
                        style={{ color: 'var(--text)' }}
                        onSelect={() => (window.location.href = '/profile')}
                    >
                        My Profile & Activities
                    </Menu.Item>
                    <Menu.Item
                        style={{ color: 'var(--text)' }}
                        onSelect={() => (window.location.href = '/profile/subscriptions')}
                    >
                        Subscriptions
                    </Menu.Item>
                    <Menu.Item
                        style={{ color: 'var(--text)' }}
                        onSelect={() => (window.location.href = '/profile/settings')}
                    >
                        Profile Settings
                    </Menu.Item>
                    <Menu.Item
                        style={{ color: 'var(--text)' }}
                        intent="danger"
                        onSelect={() => {
                            window.location.href = '/logout';
                        }}
                    >
                        Log out
                    </Menu.Item>
                </Menu>
            }
        >
            <IconButton desc="Mobile profile dropdown button" margin="0 10px 0 0">
                <UserIcon size={20} />
            </IconButton>
        </Popover>
    );
};
